export const NFT_VIEW_SPACING = {
  CONTENT_PADDING: 2.5,
  DIVIDER_MARGIN: 3.75,
  COVER_TOP_OFFSET: "96px"
};
